import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import { application } from '../application'

import CheckProducts from '../front_stage/check_products_controller'
import CleanUpField from '../front_stage/clean_up_field_controller'
import ClearConversionCookies from '../front_stage/clear_conversion_cookies_controller'
import ConsultantFormValid from '../front_stage/consultant_form_valid_controller'
import FollowUP from '../front_stage/follow_up_controller'
import FooterScroll from '../front_stage/footer_scroll_controller'
import FormUnsavedConfirm from '../front_stage/form_unsaved_confirm_controller'
import InputBox from '../front_stage/input_box_controller'
import PostCode from '../front_stage/post_code_controller'
import Pulldown from '../front_stage/pulldown_controller'
import SetConversionCookies from '../front_stage/set_conversion_cookies_controller'
import DateSelect from '../forms/inputs/date_select_controller'
import ScrollHint from '../front_stage/scroll_hint_controller'
import StructuredDataFaq from '../front_stage/structured_data_faq_controller'
import SwitcHidden from '../front_stage/switch_hidden_controller'
import TabPanel from '../front_stage/tab_panel_controller'
import TransformHalfFont from '../front_stage/transform_half_font_controller'
import RemoveHyphen from '../front_stage/remove_hyphen_controller'
import NormalizeTel from '../front_stage/normalize_tel_controller'

application.register('check-products', CheckProducts)
application.register('clean-up-field', CleanUpField)
application.register('clear-conversion-cookies', ClearConversionCookies)
application.register('consultant-form-valid', ConsultantFormValid)
application.register('follow-up', FollowUP)
application.register('footer-scroll', FooterScroll)
application.register('form-unsaved-confirm', FormUnsavedConfirm)
application.register('input-box', InputBox)
application.register('post-code', PostCode)
application.register('pulldown', Pulldown)
application.register('set-conversion-cookies', SetConversionCookies)
application.register('date-select', DateSelect)
application.register('scroll-hint', ScrollHint)
application.register('structured-data-faq', StructuredDataFaq)
application.register('switch-hidden', SwitcHidden)
application.register('tab-panel', TabPanel)
application.register('transform-half-font', TransformHalfFont)
application.register('remove-hyphen', RemoveHyphen)
application.register('normalize-tel', NormalizeTel)

const context = require.context('.', true, /_controller\.js$/)
application.load(definitionsFromContext(context))
